export const EMBEDDED_OAUTH_MESSAGE_REQUIRE_POPUP_SOURCE_FLAG =
  'growth.ecomm.embedded-oauth-message-require-popup-source.rollout';
